import { Loader2 } from 'lucide-react'

export default function Loading() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <Loader2 className="text-primary h-10 w-10 animate-spin" />
    </div>
  )
}
